import { Workstream } from '../Plan'
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "@/assets/ppm-logo.png";
import { format } from 'date-fns';
import { dateformat } from '@/utils/GlobalConstants';

const styles = StyleSheet.create({

  header: {
    flexDirection: 'row',
    backgroundColor: '#2463eb',
    color: '#FFFFFF',
    padding: 5,
    fontWeight: 'heavy',
  },
  fieldHeader: {
    backgroundColor: '#2463eb',
    color: '#FFFFFF',
    fontWeight: 'heavy',
    border: 'none',
  },
  text: {
    fontSize: 10,
    padding: 5,
    textAlign: 'justify',
    fontFamily: 'Times-Roman'
  },
  page: {
    flexDirection: 'column',
    backgroundColor: '#E4E4E4'
  },
  body: {
    flexDirection: 'row',
  },
  section: {
    flexDirection: 'column',
    width: '50%',
    paddingHorizontal: 10
  }
});

type ExportWBSPDFProps = {
  workstreams: Workstream[];
  title: string;
};

function ExportWBSPDF({ workstreams, title }: ExportWBSPDFProps) {

  return (
    <Document title="Work Breakdown Structure" author="PPMeasy" subject="Work Breakdown Structure PDF Export">
      <Page size="A4" orientation='landscape' style={styles.page}>
        <View style={styles.header}>
          <Text>Work Breakdown Structure</Text><Text style={{ marginLeft: 'auto', marginVertical: 'auto' }}>{format(new Date(), dateformat)}</Text>
        </View>
        <View style={{ flexDirection: 'row', width: '100%', paddingRight: 8 }}>
          <Image src={logo} style={{ width: "120px", marginVertical: "5px", marginHorizontal: "10px" }} />
        </View>
        <View style={{ flexDirection: 'column', width: '100%' }}>
          {/* Project Header */}
          <View style={{ flexDirection: 'row', width: '100%' }}>
            <View
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                borderRadius: 8,
                backgroundColor: '#1e3fae', // bg-planbuilder-project-header
                padding: 8,
                // boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                //minWidth: 200,
              }}
            >
              <Text
                style={{
                  fontSize: 14,
                  //fontWeight: 700,
                  color: '#ffffff', // text-planbuilder-workstream-header-foreground
                  // whiteSpace: 'nowrap',
                }}
              >
                {title}
              </Text>
            </View>
          </View>

          {GetBranchesPDF(1, workstreams.length)}

          <View style={{ flexDirection: 'row', width: '100%' }}>
            {workstreams.map((workstream) => (
              <View
                key={workstream.id}
                style={{
                  flexDirection: 'column',
                  width: `${100 / workstreams.length}%`,
                  alignItems: 'center',
                }}
              >
                {/* Workstream Header */}
                <View
                  style={{
                    borderRadius: 8,
                    backgroundColor: '#2563eb', // bg-planbuilder-workstream-header
                    padding: 8,
                    // boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                    //minWidth: 160,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      //fontWeight: 600,
                      color: '#f1f5f9', // text-planbuilder-workstream-header-foreground
                    }}
                  >
                    {workstream.name}
                  </Text>
                </View>
                {/* Branches from workstream to workPackages */}
                {GetBranchesPDF(1, workstream.workPackages.length)}

                <View style={{ flexDirection: 'row', width: '100%' }}>
                  {workstream.workPackages.map((workPackage) => (
                    <View
                      key={workPackage.id}
                      style={{
                        flexDirection: 'column',
                        width: `${100 / workstream.workPackages.length}%`,
                        alignItems: 'center',
                      }}
                    >
                      {/* WorkPackage Header */}
                      <View
                        style={{
                          borderRadius: 8,
                          backgroundColor: '#0ea5e9', // bg-planbuilder-workpackage-header
                          padding: 8,
                          // boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                          // minWidth: 120,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 10,
                            //fontWeight: 600,
                            color: '#f1f5f9', // text-planbuilder-workstream-header-foreground
                            marginVertical: 'auto',
                          }}
                        >
                          {workPackage.name}
                        </Text>
                      </View>
                      {/* Tasks rendering can be added here if needed */}
                    </View>
                  ))}
                </View>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default ExportWBSPDF

export function GetBranchesPDF(input: number, output: number) {
  const lineLength = 25; // Length of the vertical line in pixels
  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          marginLeft: 'auto',
          marginRight: 'auto',
          width: '100%',
        }}
      >
        {Array.from({ length: input + 1 }).map((_, idx) => (
          <View
            key={idx}
            style={{
              flexDirection: 'column',
              width: `${100 / (input + 1)}%`,
              height: `${lineLength}px`,
              borderRightWidth: (idx === 0 ? 2 : 0),
              borderRightColor: '#d1d5db', // Tailwind border-gray-300
            }}
          />
        ))}
      </View>
      <View style={{ flexDirection: 'row', width: '100%' }}>
        {output > 1 ? Array.from({ length: output * 2 }).map((_, idx) => (
          <View
            key={idx}
            style={{
              flexDirection: 'column',
              width: `${100 / (output * 2)}%`,
              height: `${lineLength}px`,
              borderRightWidth: idx % 2 === 0 ? 2 : 0,
              borderTopWidth: (idx !== 0 && idx !== (output * 2) - 1) ? 2 : 0,
              borderColor: '#d1d5db',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          ></View>
        )) :
          <View style={{ flexDirection: 'row', marginLeft: 'auto', marginRight: 'auto' }}>
            <View
              style={{
                flexDirection: 'column',
                width: '50%',
                height: `${lineLength}px`,
                borderRightWidth: 2,
                borderColor: '#d1d5db',
              }}
            ></View>
          </View>
        }
      </View>
    </>
  );
}